import { LinkText } from '@mediahuis/chameleon-react';
import styled from 'styled-components';

const LinkTextWithModifiedUnderline = styled(LinkText)`
  &&:hover {
    text-decoration: ${props => props.checkout10InputsDisabled && 'none'};
  }
`;
export default LinkTextWithModifiedUnderline;
